import { render, staticRenderFns } from "./DictionaryWordsEdit.vue?vue&type=template&id=18e549c6&"
import script from "./DictionaryWordsEdit.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports